(function () {
  const mq = window.matchMedia('(max-width: 768px)');

  function enhance(node) {
    if (!node) return;
    // Ensure we only enhance once
    if (node.dataset.carouselEnhanced === '1') return;
    node.dataset.carouselEnhanced = '1';

    // Wrap grid for button positioning
    const wrapper = document.createElement('div');
    wrapper.className = 'mobile-carousel-nav';
    node.parentElement.insertBefore(wrapper, node);
    wrapper.appendChild(node);

    // Build buttons
    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.className = 'mobile-carousel-btn prev';
    next.className = 'mobile-carousel-btn next';
    prev.setAttribute('aria-label', 'Previous');
    next.setAttribute('aria-label', 'Next');
    prev.textContent = '‹';
    next.textContent = '›';
    wrapper.append(prev, next);

    function slideWidth() {
      const first = node.querySelector(':scope > *');
      if (!first) return 0;
      const style = getComputedStyle(node);
      const gap = parseFloat(style.columnGap || style.gap || 16);
      return first.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', () => {
      node.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      node.scrollBy({ left:  slideWidth(), behavior: 'smooth' });
    });
  }

  function init() {
    if (!mq.matches) return;

    // Try common selectors used by Atelier for the collections list
    const grids = document.querySelectorAll(
      '.collection-list .grid, .collections-list .grid, .section--collection-list .grid'
    );
    grids.forEach(enhance);
  }

  // Run on load + whenever the editor re-renders sections
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  window.addEventListener('resize', () => {
    // If you want to re-init when crossing the breakpoint, you can refresh here
    // but we keep it lightweight.
  });
})();
